import(/* webpackMode: "eager", webpackExports: ["BlogPostClient"] */ "/app/apps/web/src/app/blog/[slug]/blog-post-client.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.28_@babel+core@7.29.0_@opentelemetry+api@1.9.1_@playwright+test@1.59.1_@types_b7b2696ecd0f8072cadd6880d59930f7/node_modules/next/dist/client/script.js");
